import { t } from '@/features/i18n/utils';
import { useWorkspace } from '@/features/workspaces/helpers';
import { WorkspaceBreadcrumbs } from '@/features/workspaces/components/workspace-breadcrumbs';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { isAxiosError } from 'axios';
import { BreadcrumbLink, BreadcrumbPage } from '@/ui/components/breadcrumb';
import { Header, HeaderChatButton, HeaderBackButton } from '@/ui/components/header';
import { clauseSubcategoryQuery } from '@/features/clauses/queries';
import { ClausesSubCategoryPage } from '@/features/clauses/components/clauses-sub-category-page';
import { useSuspenseQuery } from '@tanstack/react-query';
import { workspaceQuery } from '@/features/workspaces/queries';

export const Route = createFileRoute(
  '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/clauses/$subcategoryId/',
)({
  staticData: { chatSurface: 'clause_scanner' },
  component: RouteComponent,
  loader: async ({ context, params }) => {
    const workspace = await context.queryClient.query({
      ...workspaceQuery(params.workspaceId),
      staleTime: 'static',
    });
    const subcategory = await context.queryClient
      .query({
        ...clauseSubcategoryQuery(workspace.type, params.workspaceId, params.subcategoryId),
        staleTime: 'static',
      })
      .catch((error: unknown) => {
        if (isAxiosError(error) && error.response?.status === 404) return null;
        throw error;
      });
    if (!subcategory) throw notFound();
  },
});

function RouteComponent() {
  const { workspaceId, projectId, subcategoryId } = Route.useParams();
  const workspace = useWorkspace();

  const { data } = useSuspenseQuery(
    clauseSubcategoryQuery(workspace.type, workspaceId, subcategoryId),
  );

  return (
    <>
      <Header>
        <HeaderBackButton
          to="/project/$projectId/workspaces/$workspaceId/clauses"
          params={{ projectId, workspaceId }}
        />
        <WorkspaceBreadcrumbs>
          <BreadcrumbLink
            to="/project/$projectId/workspaces/$workspaceId/clauses"
            params={{ projectId, workspaceId }}
          >
            {t({ en: 'Clauses', nb: 'Klausuler' })}
          </BreadcrumbLink>
          <BreadcrumbPage>{data.name}</BreadcrumbPage>
        </WorkspaceBreadcrumbs>
        <HeaderChatButton />
      </Header>
      <ClausesSubCategoryPage />
    </>
  );
}
